import { render, staticRenderFns } from "./FormDependentEnderecos.vue?vue&type=template&id=6c7a13dc"
import script from "./FormDependentEnderecos.vue?vue&type=script&lang=js"
export * from "./FormDependentEnderecos.vue?vue&type=script&lang=js"
import style0 from "./FormDependentEnderecos.vue?vue&type=style&index=0&id=6c7a13dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports